import React from 'react'
import Modal from '~/components/Modal'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

interface DetailsModalProps {
  show: boolean
  handleClose: () => void
  detail: any
}

const DetailsModal: React.FC<DetailsModalProps> = ({ show, handleClose, detail }) => {
  const { t: translate } = useTranslation()
  let parsedDetail = detail
  if (typeof detail === 'string') {
    try {
      parsedDetail = JSON.parse(detail)
    } catch (e) {
      parsedDetail = detail
    }
  }

  const renderDetailContent = () => {
    if (!parsedDetail) {
      return <span>{translate('NO_DETAILS_AVAILABLE')}</span>
    }

    if (Array.isArray(parsedDetail) && parsedDetail.length === 2) {
      return (
        <div>
          <div style={{ fontWeight: 600, marginBottom: 4, textAlign: 'left' }}>BEFORE</div>
          {Object.entries(parsedDetail[0]).map(([key, value]) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontWeight: 600, width: 180, paddingRight: 32, verticalAlign: 'top', textAlign: 'left' }}>
                {key}
              </span>
              <span style={{ fontWeight: 400, flex: 1, textAlign: 'left', verticalAlign: 'top', paddingLeft: 0 }}>
                {value === undefined || value === null || value === '' ? '-' : String(value)}
              </span>
            </div>
          ))}
          <div style={{ fontWeight: 600, marginTop: 12, marginBottom: 4, textAlign: 'left' }}>AFTER</div>
          {Object.entries(parsedDetail[1]).map(([key, value]) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontWeight: 600, width: 180, paddingRight: 32, verticalAlign: 'top', textAlign: 'left' }}>
                {key}
              </span>
              <span style={{ fontWeight: 400, flex: 1, textAlign: 'left', verticalAlign: 'top', paddingLeft: 0 }}>
                {value === undefined || value === null || value === '' ? '-' : String(value)}
              </span>
            </div>
          ))}
        </div>
      )
    }

    if (Array.isArray(parsedDetail)) {
      return parsedDetail.map((item: any) => (
        <div key={_.uniqueId()} style={{ marginBottom: 8 }}>
          {Object.entries(item).map(([key, value]) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontWeight: 600, width: 180, paddingRight: 32, verticalAlign: 'top', textAlign: 'left' }}>
                {key}
              </span>
              <span style={{ fontWeight: 400, flex: 1, textAlign: 'left', verticalAlign: 'top', paddingLeft: 0 }}>
                {value === undefined || value === null || value === '' ? '-' : String(value)}
              </span>
            </div>
          ))}
        </div>
      ))
    }

    if (typeof parsedDetail === 'object') {
      return Object.entries(parsedDetail).map(([key, value]) => (
        <div key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <span style={{ fontWeight: 600, width: 160, paddingRight: 24, verticalAlign: 'top', textAlign: 'left' }}>
            {key}
          </span>
          <span style={{ fontWeight: 400, flex: 1, textAlign: 'left', verticalAlign: 'top', paddingLeft: 0 }}>
            {value === undefined || value === null || value === '' ? '-' : String(value)}
          </span>
        </div>
      ))
    }

    if (typeof parsedDetail === 'string') {
      return <span>{parsedDetail}</span>
    }

    return <span>{translate('NO_DETAILS_AVAILABLE')}</span>
  }

  return (
    <Modal show={show} handleClose={handleClose} title={translate('REPORTS_ACTIVITY_DETAIL_TITLE')}>
      <Modal.Body>{renderDetailContent()}</Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Button variant="primary" onClick={handleClose}>
          {translate('CLOSE')}
        </Modal.Footer.Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DetailsModal
